import styled from 'styled-components';

export const PropertyTypeButtonWrapper = styled.div`
    //background-color: ${props => props.selected ? '#4A148C' : '#F3E5F5' };
    background-color: ${props => props.selected ? '#26794f' : '#f4f4f4' };
    border-radius: 10px;
    min-width: 150px;
    margin: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    p{
        //color: ${props => props.selected ? '#fff' : '#4A148C' };
        color: ${props => props.selected ? '#fff' : '#26794f' };
    }
    
    &:hover{
        //background: #4A148C;
        background: #f0a808;
        cursor: pointer;
        svg{
            color: #fff;
        }
        p{
            color: #fff;
        }
    }
`

export const Iconwrapper = styled.div`
    margin-top: 9px;
    svg{
        font-size: 2.0em;
        //color: ${props => props.selected ? '#fff' : '#4A148C' };
        color: ${props => props.selected ? '#fff' : '#26794f' };
    }
    
`;